module.exports = __webpack_public_path__ + "static/Truck13-c8ab12978d95c1ad330d3c6381e68e80.png";